// src/components/PacoAvatar.jsx
import React from 'react';
import { ReactComponent as PacoBot } from '../assets/Paco-bot.svg';

const PacoAvatar = ({ size = 200 }) => (
  <PacoBot width={size} height="auto" />
);

export default PacoAvatar;